<template>
  <div class="courseWrap">
    <div :class="isMobile.isMobile?'isMobileWrap':'md-layout isMobileWrap'"  v-if="cardType == 0">
      <div
        v-for="item in courseList"
        cols="auto"
        :key="item._id"
        :max-height="isMobile.isMobile ? '105' : '235'"
        :height="isMobile.isMobile ? '105' : '235'"
        :class="
          isMobile.isMobile
            ? 'courseList'
            : 'md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseList'
        "
      >
        <v-card
          elevation="2"
          :max-height="isMobile.isMobile ? '105' : '235'"
          :height="isMobile.isMobile ? '105' : '235'"
          style="width: 100%"
          class="cardWrap"
        >
          <v-img
            :lazy-src="item.sourse_image ? item.sourse_image : scoureImg"
            class="coureListImg"
            :height="isMobile.isMobile ? '80px' : '190px'"
            :max-height="isMobile.isMobile ? '80px' : '190px'"
            max-width="100%"
            :src="item.sourse_image ? item.sourse_image : scoureImg"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="rightTag">
            <v-btn
              v-if="tabIndex == 1 || tabIndex == 0"
              icon
              :color="item.isCollect ? 'red' : 'grey'"
              :class="tabIndex == 0 ? 'pubcollect' : ''"
              @click.stop="clickcollect(item)"
            >
              <span
                class="material-icons"
                :style="{ fontSize: isMobile.isMobile ? '20px' : '30px' }"
                >favorite</span
              >
              <md-tooltip md-direction="top">点击收藏</md-tooltip>
            </v-btn>

            <v-btn icon v-show="tabIndex == 1" @click="inviteFn(item)">
              <span
                class="iconfont icon-zhuceyaoqing"
                :style="{ fontSize: isMobile.isMobile ? '20px' : '24px', color: '#fff' }"
              ></span>
              <md-tooltip md-direction="top">邀请协作成员</md-tooltip>
            </v-btn>

            <v-btn icon v-show="tabIndex == 2" @click="inviteFnMessage(item)">
              <span
                class="iconfont icon-yulan4"
                :style="{ fontSize: isMobile.isMobile ? '20px' : '24px', color: '#fff' }"
              ></span>
              <md-tooltip md-direction="top">邀请信息</md-tooltip>
            </v-btn>

            <div class="selectWrapAdd" v-show="tabIndex !== 0">
              <v-btn @click.stop icon>
                <v-icon style="color: #fff">mdi-dots-vertical</v-icon>
              </v-btn>
              <div class="selectContent">
                <p
                  v-for="(items, index) in editList"
                  :key="index"
                  @click.stop="goToSettiing(item, items)"
                >
                  <span
                    v-if="items.type == 'edit'"
                    v-hasPermi="['dev::course::edit']"
                    class="iconfont icon-bianji1"
                    style="color: #fff; font-size: 13px; margin-right: 5px"
                  ></span>

                  <span
                    v-if="items.type == 'delete'"
                    v-hasPermi="['dev::course::remove']"
                    class="iconfont icon-shanchutianchong"
                    style="display: inline-block; font-size: 13px; margin-right: 5px"
                  ></span>
                  <v-icon
                    v-if="items.type == 'copy'"
                    style="color: #fff; font-size: 13px; margin-right: 5px"
                    small
                    >mdi-content-copy</v-icon
                  >
                  <span
                    v-if="items.type == 'history'"
                    class="iconfont icon-jilu1"
                    style="color: #fff; display: inline-block; font-size: 13px; margin-right: 5px"
                  ></span>
                  <span>{{ items.title }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="coureNameWrap">
            <p>{{ coureItem(item) }}</p>

            <div
              style="
                display: inline-block;
                height: 40px;
                line-height: 40px;
                width: 30%;
                overflow: hidden;
              "
              class="intoCourse"
            >
              <span
                @click.stop="goToCoureDetail(item)"
                v-hasPermi="['dev::course::edit']"
                style="color: #000; margin-right: 3px; float: right"
              >
                {{ tabIndex == 0 ? '浏览课程' : '编辑课程' }}
                <span
                  class="iconfont icon-jiantou_yemian_xiangyou intoCourseIon"
                  style="font-size: 22px; vertical-align: bottom"
                ></span>
              </span>
            </div>
          </div>

          <div class="editWrap">
            <div :style="{ width: '100%', height: '80px', overflow: 'hidden' }">
              <div class="leftTag">
                <p class="tagKey">
                  <span>签约学校</span>
                  : {{ item.university || '' }}
                </p>
                <p class="tagKey">
                  <span>学院/系</span>
                  : {{ item.college || '' }}
                </p>
                <p class="tagKey">
                  <span>教研团队</span>
                  : {{ item.team || '' }}
                </p>
                <p class="tagKey">
                  <span>负责人</span>
                  : {{ item.manager || '' }}
                </p>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <div
        v-if="tabIndex == 1 && courseList.length < 8&&!isMobile.isMobile"
        :class="isMobile.isMobile? 'createCourse':'md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 createCourse'"
        @click="toNewCourse"
      >
        <v-card
          elevation="2"
          :style="{
            width: '100%',
            height: isMobile.isMobile?'105px':'235px',
            background: '#e8e8e8',
            boxShadow:'0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)'
          }
          "
        >
          <span class="iconfont icon-tianjia addIcon"></span>
          <span class="addText">创建课程</span>
        </v-card>
      </div>
    </div>
    <div v-if="cardType == 1 && courseList.length > 0" style="width: 100%">
      <v-data-table
        hide-default-footer
        :headers="headers"
        :items="courseList"
        :sort-by="['currentSort', 'currentSortOrder']"
        no-data-text="暂无课程"
        :sort-desc="[false, true]"
        multi-sort
        :items-per-page="20"
        class="table-striped table-hover mx-5"
        style="min-height: 500px"
      >
        <template v-slot:item.num="{ item }">{{ item.num }}</template>
        <template v-slot:item.name="{ item }">
          {{ item.name }}
          <md-tooltip md-direction="top">{{ item.name }}</md-tooltip>
        </template>
        <template v-slot:item.university="{ item }">
          {{ item.university }}
          <md-tooltip md-direction="top">{{ item.university }}</md-tooltip>
        </template>

        <template v-slot:item.college="{ item }">
          {{ item.college }}
          <md-tooltip md-direction="top">{{ item.college }}</md-tooltip>
        </template>

        <template v-slot:item.team="{ item }">
          {{ item.team }}
          <md-tooltip md-direction="top">{{ item.team }}</md-tooltip>
        </template>

        <template v-slot:item.refer="{ item }">{{ item.refer | referFilter }}</template>
        <template v-slot:item.optionone="{ item }">
          <div style="position: relative; overflow: hidden">
            <v-btn
              v-if="tabIndex == 1"
              icon
              :color="item.isCollect ? 'red' : 'grey'"
              @click.stop="clickcollect(item)"
            >
              <span class="material-icons" style="font-size: 30px">favorite</span>
              <md-tooltip md-direction="top">点击收藏</md-tooltip>
            </v-btn>
            <v-btn icon v-show="tabIndex == 1" @click="inviteFn(item)">
              <span class="iconfont icon-zhuceyaoqing" style="font-size: 24px; color: gray"></span>
              <md-tooltip md-direction="top">邀请协作成员</md-tooltip>
            </v-btn>
            <span
              @click.stop="goToCoureDetail(item)"
              v-hasPermi="['dev::course::edit']"
              style="
                color: gray;
                margin-right: 3px;
                margin: 0 auto;
                line-height: 40px;
                height: 40px;
                cursor: pointer;
              "
            >
              <v-icon small style="font-size: 20px">mdi-pencil</v-icon>
              <md-tooltip md-direction="top">
                {{ tabIndex == 0 ? '浏览课程' : '编辑课程' }}</md-tooltip
              >
            </span>

            <div class="selectWrapAdd" v-show="tabIndex !== 0">
              <v-menu
                open-on-hover
                style="position: relative"
                nudge-left="100"
                :offset-y="y"
                nudge-width="20"
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn v-bind="attrs" icon v-on="on" fab dark small>
                    <v-icon style="color: rgba(0, 0, 0, 0.54)">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(items, index) in editList"
                    :key="index"
                    @click.stop="goToSettiing(item, items)"
                  >
                    <v-list-item-title>
                      <span
                        v-if="items.type == 'edit'"
                        v-hasPermi="['dev::course::edit']"
                        class="iconfont icon-bianji1"
                        style="color: #000; font-size: 13px; margin-right: 5px"
                      ></span>

                      <span
                        v-if="items.type == 'delete'"
                        v-hasPermi="['dev::course::remove']"
                        class="iconfont icon-shanchutianchong"
                        style="
                          color: #7b809a;
                          display: inline-block;
                          font-size: 13px;
                          margin-right: 5px;
                        "
                      ></span>

                      <span
                        v-if="items.type == 'history'"
                        class="iconfont icon-jilu1"
                        style="
                          color: #7b809a;
                          display: inline-block;
                          font-size: 13px;
                          margin-right: 5px;
                        "
                      ></span>

                      <v-icon
                        v-if="items.type == 'copy'"
                        style="color: #000; font-size: 13px; margin-right: 5px"
                        small
                        >mdi-content-copy</v-icon
                      >

                      <span>{{ items.title }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </template>

        <!-- optionone -->
      </v-data-table>
    </div>
    <!-- <div
      v-if="courseListLoading && courseList.length <= 0"
      style="
        overflow: hidden;
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        margin: 0 auto;
        left: 0;
        right: 0;
      "
      class="md-layout"
    >
      <v-sheet
        v-for="(index, item) in 8"
        :key="index"
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseList"
      >
        <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
      </v-sheet>
    </div> -->
    <div style="margin-top: 10px; margin-bottom: 20px">
      <div style="overflow: hidden">
        <v-pagination
          prev-icon="fa fa-angle-left"
          next-icon="fa fa-angle-right"
          class="pagination"
          color="#4caf50"
          :value="pagination.page"
          :length="pageCount"
          @input="inputChange"
          circle
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>
    <v-dialog v-model="dialogTableVisible" max-width="600"  scrollable  transition="dialog-bottom-transition">
      <v-card>
        <v-card-text>
        <div class="d-flex align-end mb-3">
          <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
            <v-icon color="white"> mdi-bookmark </v-icon>
          </v-card>
          <span class="h4 ml-1 mb-n1"
            >该
            <span style="font-weight: bold">{{ titleTag }}</span> 课程可邀请以下成员共同协作</span
          >
        </div>
      <div>
        <v-text-field
          v-model="form.name"
          :counter="10"
          label="协作成员名称"
          placeholder="查询协作成员名称"
          style="padding-right: 10px; padding-left: 10px"  
          @keyup.enter.native="keydownSearch"
        ></v-text-field>
        <md-tooltip md-direction="top" style="z-index: 99999;">按回车以检索</md-tooltip>
      </div>


        <el-table :data="userTableData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"> </el-table-column>
          <el-table-column align="center" property="date" label="头像" width="100">
            <template slot-scope="scope">
              <!-- scope.$index, scope.row -->
              <div class="block">
                <el-avatar
                  :size="40"
                  :src="scope.row.avatar ? scope.row.avatar : require('../../assets/img/log.png')"
                ></el-avatar>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" property="nickName" label="用户"></el-table-column>
        </el-table>
        <div style="overflow: hidden; text-align: right">
          <v-pagination
            style="float: right"
            prev-icon="fa fa-angle-left"
            next-icon="fa fa-angle-right"
            color="#4caf50"
            :value="tablepagination.page"
            :length="tablepageCount"
            @input="tableinputChange"
            circle
            :total-visible="7"
          ></v-pagination>
        </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="submit">提交</v-btn>
          <v-btn color="gray" @click="dialogTableVisible = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 协作课程弹窗 -->
    <v-dialog v-model="dialogMessageVisible" width="500" transition="dialog-bottom-transition">
      <v-card>
        <div class="d-flex align-end mb-3">
          <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
            <v-icon color="white"> mdi-bookmark </v-icon>
          </v-card>
          <v-card-title class="text-h5 lighten-2"> 课程协作记录 </v-card-title>
          <!-- <span class="h4 ml-1 mb-n1"
            >该
            <span style="font-weight: bold">{{ titleTag }}</span> 课程可邀请以下成员共同协作</span
          > -->
        </div>

        <v-card-text>
          <p style="margin: 15px 0">
            该课程&nbsp;《{{ thisMessage.name }}》&nbsp;由
            <strong>{{ thisMessage.nickName }}</strong> 发起邀请
          </p>
          <p style="margin: 15px 0">
            于 <strong>{{ dateFormat(thisMessage.created_at) }}</strong> 发起邀请
          </p>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="dialogMessageVisible = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 协作课程弹窗 -->

    <!-- 我的课程邀请记录弹窗 -->

    <v-dialog v-model="inviteVisible" width="600" transition="dialog-bottom-transition">
      <v-card>
        <div class="d-flex align-end mb-3">
          <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
            <v-icon color="white"> mdi-bookmark </v-icon>
          </v-card>

          <v-card-title class="text-h5 lighten-2">
            当前&nbsp;<strong>{{ inviteItem.name }}</strong
            >&nbsp;课程邀请协作成员记录
          </v-card-title>
        </div>

        <v-card-text>
          <v-data-table
            :headers="inviteHeaders"
            :items="inviteData"
            :items-per-page="5"
            class="elevation-1"
            hide-default-footer
          >
            <template v-slot:item.name="{ item }">
              <span>{{ item.name }}</span>
            </template>
            <template v-slot:item.nickName="{ item }">
              <span>{{ item.nickName }}</span>
            </template>
            <template v-slot:item.InviteeName="{ item }">
              <span>{{ item.InviteeName }}</span>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{ dateFormat(item.created_at) }}</span>
            </template>
            <template v-slot:item.optionone="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="historyBack(item)">
                    <span class="iconfont icon-chehui iconStyle" v-if="item.status == 1"></span>
                    <span
                      class="iconfont icon-zhongxinfasong"
                      style="color: green"
                      v-if="item.status == 4"
                    ></span>
                  </v-btn>
                </template>
                <span>{{ item.status == 1 ? '撤回邀请' : '重新邀请' }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="inviteVisible = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 我的课程邀请记录弹窗 -->
  </div>
</template>
 
<script>
import { mapGetters } from 'vuex';
import {
  delCourse,
  deleteCopy,
  setcollect,
  copyCourse,
  getUserList,
  setInvite,
  queryInvite,
getInviteHistory,
  historyBack,
} from '@/api/course';
import moment from 'moment';
import store from '../../store/modules/courseAndProject.js';
import Swal from 'sweetalert2';
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'isMobile']),
    cardType() {
      return this.$store.state.task.cardType;
    },
    tablepageCount() {
      return this.tablepagination.total
        ? Math.ceil(this.tablepagination.total / this.tablepagination.itemsPerPage)
        : 0;
    },

    pageCount() {
      return this.pagination.total
        ? Math.ceil(this.pagination.total / this.pagination.itemsPerPage)
        : 0;
    },

    courseListPage() {
      return this.$store.state.task.courseListPage;
    },
  },
  props: {
    tabIndex: {
      default: '',
      type: Number,
    },
  },

  filters: {
    referFilter(val) {
      if (!val) return '';

      const list = [
        {
          key: 'bk',
          value: '本科',
        },
        {
          key: 'gz',
          value: '高职',
        },
        {
          key: 'gj',
          value: '高技',
        },
        {
          key: 'zz',
          value: '中职',
        },
        {
          key: 'jx',
          value: '技校',
        },
        {
          key: 'bjrs',
          value: '毕节人社',
        },
      ];
      return typeof val === 'string'
        ? list.find(item => item.key === val)?.value
        : list
            .filter(item => val.some(i => i === item.key))
            .map(item => item.value)
            .join('、');
    },
  },
  watch: {
    '$store.state.courseAndProject.courseList': {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        if (val.length > 0) {
          this.courseListLoading = false;
        }
      },
      deep: true, //true 深度监听
    },

    // store.state.courseList(news){
    //   console.log(news,'11111')
    // },
    toggle_exclusive(news) {
      this.$store.state.task.cardType = news;
    },
    // 'pagination.itemsPerPage'(item) {
    //   this.pagination.page = 1;
    //   this.queryData();
    //   this.saveCourseForm.perPage = item;
    // },
    'queryParams.name'() {},

    'pagination.page'(item) {
      this.$store.state.task.courseListPage = this.pagination;
      this.saveCourseForm.currentPage = item;
    },
    refer(item) {
      this.saveCourseForm.refer = item;
    },
    majorGroup(item) {
      this.saveCourseForm.majorGroup = item;
    },
    majorGroup2(item) {
      this.saveCourseForm.majorGroup2 = item;
    },
    dialogTableVisible(news) {
      if (news) {
        this.getUserList();
      } else {
        this.tablepagination.page = 1;
      }
    },
  },
  data() {
    return {
      inviteVisible: false,
      inviteHeaders: [
        { text: '课程名称', align: 'center', value: 'name' },
        { text: '邀请人', align: 'center', value: 'nickName' },
        { text: '被邀请人', align: 'center', value: 'InviteeName' },
        { text: '邀请时间', align: 'center', value: 'created_at' },
        {
          text: '操作',
          align: 'center',
          value: 'optionone',
          // sortable: false,
        },
      ],
      inviteData: [],
      titleTag: '',
      userAll: [],
      tablepagination: {
        page: 1,
        itemsPerPage: 6,
        total: 0,
        // name: "",
        perPageOptions: [6, 12, 24],
      },
      form: {
        name: '',
      },
      dialogTableVisible: false,
      userTableData: [],
      courseListLoading: false,
      queryParams: {},
      optionsValue: ['all'],
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
        // name: "",
        perPageOptions: [8, 12, 16, 20],
      },
      saveCourseForm: {
        // currentPage: _this.pagination.page,
        currentPage: '',
        // perPage: _this.pagination.itemsPerPage,
        perPage: '',
        // name: _this.queryParams.name,
        name: '',
        // filterValue: this.select.abbr,
        // refer: this.refer||"",
        refer: '',
        // majorGroup: this.majorGroup||"",
        majorGroup: '',
        // majorGroup2: this.majorGroup2||"",
        majorGroup2: '',
      },
      x: true,
      y: true,
      currentSort: 'name',
      currentSortOrder: 'asc',
      headers: [
        {
          text: '序 号',
          align: 'start',
          value: 'num',
          width: 90,
        },
        { text: '名 称', align: 'start', value: 'name' },
        { text: '签约院校', align: 'start', value: 'university' },
        { text: '学院/系', align: 'start', value: 'college' },
        { text: '教研团队', align: 'start', value: 'team' },
        { text: '适 用', align: 'start', value: 'refer' },
        { text: '负责人', align: 'start', value: 'manager', width: 120 },
        {
          text: '操作',
          align: 'center',
          value: 'optionone',
          sortable: false,
        },
      ],
      tableData: [],
      editList: [
        {
          title: '修改课程信息',
          type: 'edit',
        },
        {
          title: '删除课程',
          type: 'delete',
        },
        {
          type: 'copy',
          title: '复制课程',
        },
        {
          type: 'history',
          title: '协作记录',
        },
      ],
      scoureImg: require('/public/img/log.png'),
      clickCourse: {},
      thisMessage: {},
      dialogMessageVisible: false,
      inviteItem: {},
      course: {},
    };
  },
  methods: {
    //撤回邀请
    historyBack(item) {
      let params = {
        status: 1,
        id: item._id || '',
      };
      if (item.status == 4) {
        params.status = 1;
      } else if (item.status == 1) {
        params.status = 4;
      }
      let _this = this;
      historyBack(params).then(res => {
        if (res.code == '200') {
          if (item.status == 1) {
            _this.$message.success('已撤回邀请!');
          } else if (item.status == 4) {
            _this.$message.success('已重新邀请!');
          }

          _this.handleHistory(this.course);
          // _this.inviteVisible = false;
        }
      });
    },
    //邀请协作成员
    submit() {

      if(this.userAll.length<=0){
        this.$message.warning('请先勾选协作者!');
        return
      }
      let params = {
        courseId: this.clickCourse._id, //课程id
        Invitee: this.userAll, //被邀请人
        Inviter: this.getUser().userId, //邀请人
        nickName: this.getUser().nickName, //邀请人姓名
        status: 1,
      };
      setInvite(params).then(res => {
        this.dialogTableVisible = false;
        this.form.name = '';
        this.$message.success('邀请协作成员成功!');
      });
    },
    inviteFnMessage(item) {
      this.thisMessage = item;
      this.dialogMessageVisible = true;
    },
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.tablepagination.page = 1;
        this.getUserList();
      }
    },
    handleSelectionChange(e) {
      this.userAll = e.map(item => {
        return {
          id: item._id,
          nickName: item.nickName,
        };
      });
    },

    tableinputChange(e) {
      this.tablepagination.page = e;
      this.getUserList();
    },
    getUserList() {
      let data = {
        tab: 2,
        currentPage: this.tablepagination.page,
        perPage: this.tablepagination.itemsPerPage,
        name: this.form.name || '',
        is_open: this.courseType(),
      };
      getUserList(data).then(res => {
        this.userTableData = res.data.row;
        this.tablepagination.total = res.data.total;
      });
    },
    inviteFn(item) {
      this.clickCourse = item;
      this.titleTag = item.name;
      this.dialogTableVisible = true;
    },
    toNewCourse() {
      this.$router.push({ path: './newcourse' });
    },
    setSearchQuery(data) {
      this.queryParams = data;
      this.createCourse();
    },
    selectCard(data) {
      this.optionsValue = data;
      if (this.tabIndex == 2) {
        this.queryInviteData();
        return;
      }
      this.createCourse();
    },
    inputChange(e) {
      if (this.tabIndex == 2) {
        this.pagination.page = e;
        this.queryInviteData();
        return;
      }
      this.pagination.page = e;
      this.queryData();

      // this.createCourse()
    },
    async queryData() {
      this.courseListLoading = true;
      let _this = this;
      let params = {
        currentPage: _this.pagination.page,
        perPage: _this.pagination.itemsPerPage,
        name: _this.queryParams.name || '',
        // filterValue: this.select.abbr,
        refer: this.optionsValue[0] == '' ? 'all' : this.optionsValue[0] || '',
        majorGroup: this.optionsValue[1] == 'all' ? '' : this.optionsValue[1] || '',
        majorGroup2: this.optionsValue[2] == 'all' ? '' : this.optionsValue[2] || '',
        is_open: _this.courseType(),
        createUserId: _this.getUser().userId,

        fn: function (result) {
          _this.courseListLoading = false;
          result.data.rows.forEach((item, index) => {
            item.num = index + 1;
          });
          _this.pagination.total = result.data.total;
        },
      };

      window.localStorage.setItem('courseCache', JSON.stringify(params));
      await this.$store.dispatch('courseAndProject/refreshCourseList', params);
    },
    goToSettiing(item, items) {
      this.course = item;
      switch (items.type) {
        case 'edit':
          this.handleEdit(item);
          break;

        case 'copy':
          this.handleCopy(item);
          break;

        case 'delete':
          this.handleDelete(item);
          break;
        case 'history':
          this.handleHistory(item);
          break;
      }
    },
    handleEdit(item) {
      item.isEdit = 'edit';
      this.$router.push({
        path: 'newcourse',
        query: { courseId: item._id, tab: this.tabIndex, type: 'edit' },
      }); // 页面跳转
    },
    async handleCopy(item) {
      let result = await Swal.fire({
        title: '复制信息',
        text: `${item.name} 确定要复制该项目?请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
        reverseButtons: true,
      });
      if (result.value) {
        let params = {
          id: item._id || '',
        };
        const delResult = await copyCourse(params);
        if (delResult.code == 200) {
          this.createCourse();
          this.$notify({
            timeout: 1500,
            message: '复制成功',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.$emit('setParentTab');
        }
      }
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 记录被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
        reverseButtons: true,
      });
      if (result.value) {
        const delResult = await delCourse(item);
        if (delResult.code == 200) {
          this.pagination.page = 1;
          this.createCourse();
          Swal.fire({
            title: '已删除!',
            text: `您已经删除 ${item.name}`,
            type: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false,
          });
        }
      }
    },

    //历史记录
    async handleHistory(item) {
      this.inviteItem = item;
      this.inviteVisible = true;
      getInviteHistory({ courseId: item._id }).then(res => {
        if (res.code == '200') {
          res.data.forEach(items => {
            items.name = item.name;
          });
          this.inviteData = res.data;
        }
      });
    },
    getUser() {
      if (window.localStorage.getItem('USER_INFO')) {
        let userData = JSON.parse(window.localStorage.getItem('USER_INFO'));
        if (userData && userData.user) {
          return {
            userId: userData.user._id,
            nickName: userData.user.nickName,
          };
        }
      }
    },

    goToCoureDetail(item) {
      this.$router.push({
        name: 'designDetail',
        query: {
          detailId: item._id,
          tab: this.tabIndex,
        },
      });
    },

    clickcollect(data) {
      // let isCollect = !data.isCollect;

      let params = {
        isCollect: data.isCollect == 1 ? 0 : 1,
        date: new Date(),
        _id: data._id,
      };
      if (params.isCollect == 0) {
        var date = new Date(2022, 9 - 1, 30, 8, 30);
        params.date = date;
      } else if (params.isCollect == 1) {
        params.date = new Date();
      }
      setcollect(params).then(res => {
        if (res.code == '200') {
          // data.isCollect = isCollect;
          this.createCourse();
          this.$notify({
            timeout: 1500,
            message: data.isCollect == 0 ? '收藏成功' : '取消收藏',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
        }
      });
    },
    coureItem(item) {
      return item.name;
    },
    courseType() {
      let courseType = null;
      if (this.tabIndex == 0) {
        courseType = 'publicCourse';
      } else if (this.tabIndex == 1) {
        courseType = 'myCourse';
      } else if (this.tabIndex == 2) {
        courseType = 'collaborateCourse';
      }
      return courseType;
    },
    async queryInviteData() {
      let _this = this;
      let params = {
        name: this.queryParams.name,
        is_open: _this.courseType(),
        userId: _this.getUser().userId, //邀请人
        pageNum: _this.pagination.page,
        pageSize: _this.pagination.itemsPerPage,
        refer: this.optionsValue[0] == '' ? 'all' : this.optionsValue[0] || '',
        majorGroup: this.optionsValue[1] == 'all' ? '' : this.optionsValue[1] || '',
        majorGroup2: this.optionsValue[2] == 'all' ? '' : this.optionsValue[2] || '',
        tabIndex: this.tabIndex,
        status: '1',
      };
      queryInvite(params).then(async res => {
        _this.courseListLoading = false;
        await this.$store.dispatch('courseAndProject/getQueryInvite', res.data.rows);
        _this.pagination.total = res.data.total;
      });
    },

    async createCourse() {
      if (this.tabIndex == 0) {
        this.pagination.page = 1;
        this.queryData();
      } else if (this.tabIndex == 1) {
        this.pagination.page = 1;
        this.queryData();
      } else if (this.tabIndex == 2) {
        this.pagination.page = 1;
        this.queryInviteData();
      }
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
  },
  created() {
    if (JSON.stringify(this.courseListPage) !== '{}') {
      this.pagination.page = this.courseListPage.page;
      this.pagination.itemsPerPage = this.courseListPage.itemsPerPage;
    }
    this.createCourse();
  },
  mounted() {
    this.courseListLoading = true;
    if (this.tabIndex == 2) {
      this.editList = [
        {
          title: '修改课程信息',
          type: 'edit',
        },
        {
          type: 'copy',
          title: '复制课程',
        },
      ];
      // {
      //     title: '删除课程',
      //     type: 'delete',
      //   },
    }
  },
};
</script>

<style scoped>
.pubcollect {
  margin-right: 10px;
}
.courseWrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-top: 10px;
  min-height: 580px;
  position: relative;
}

.courseList:hover .coureListImg {
  opacity: 0.8;
}

.coureListImg >>> .v-image__image {
  background-size: 100% 100% !important;
}

.courseList:hover .editWrap {
  margin: auto;
  width: 100%;
  height: 190px;
  top: 0px;
  background: #000000a3;
  display: block;
}
.coureListImg {
  width: 100%;
  transition: 0.2s;
}

.rightTag {
  float: right;
  z-index: 99;
  width: auto;
  height: auto;
  position: absolute;
  right: 0px;
  top: 0px;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}
.selectWrapAdd:hover .selectContent {
  display: block;
}

.selectContent {
  z-index: 999999;
  position: absolute;
  top: 35px;
  right: 20px;
  width: 110px;
  height: auto;
  padding: 10px 5px;
  background: #000000a3;
  display: none;
  overflow: hidden;
  border-radius: 5px;
}
.selectContent p {
  text-align: left;
  margin: 0px;
  margin-bottom: 5px;
}
.selectContent p:hover {
  background: #343434;
}
.selectContent p span {
  color: #fff;
  font-size: 13px;
}

.coureNameWrap {
  width: 100%;
  height: 40px;
  margin-top: 5px;
  text-align: center;
}
.coureNameWrap p {
  float: left;
  width: 70%;
  height: 40px;
  line-height: 40px;
  color: #000;
  font-size: 14px;
  /* margin-top: 6px; */
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  padding: 0 5px;
}

.coureNameWrap > span {
  display: block;
  margin-right: 5px;
  float: right;
  padding: 0 5px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
}

.leftTag {
  float: left;
  width: 70%;
  text-align: left;
  padding: 10px 0;
}
.leftTag p {
  width: 100%;
  margin-bottom: 2px;
  color: #fff;
  text-indent: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  font-size: 13px;
}

.editWrap {
  position: absolute;
  width: 100%;
  height: 190px;
  line-height: 40px;
  transition: 0.5s;
  top: 0px;
  text-align: right;
  display: none;
  transition: 0.5s;
}

.editWrap > span {
  display: inline-block;
  transform: translateY(130px);
}
.editWrap > span:nth-child(2) {
  margin-right: 10px;
}
.editWrap >>> svg {
  width: 1.8em !important;
  height: 1.8em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-left: 20px;
  margin-top: 20px;
  color: #fff;
  display: none;
}

.coureWraps >>> .v-card:hover .editWrap svg {
  display: inline;
}

.courseList {
  /* margin: 10px 0; */
  /* height: 245px;
  max-height: 245px; */
  cursor: pointer;

  padding-right: 10px !important;
  padding-left: 10px !important;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}
.md-layout {
  min-height: 490px;
}

.pagination {
  /* margin: 0 auto; */
  margin-right: 30px;
  float: right;
  padding: 0;
  overflow: hidden;
}
.createCourse {
  /* margin: 10px 0; */
  height: 235px;
  max-height: 235px;
  cursor: pointer;
  border-radius: 4px;
  padding-right: 10px !important;
  padding-left: 10px !important;

  position: relative;
}
.createCourse .addIcon {
  position: absolute;
  top: 40px;
  left: 40px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 45px;
}

.createCourse .addText {
  position: absolute;
  bottom: 40px;
  left: 40px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 30px;
}

.iconStyle {
  font-size: 20px;
  color: red;
}

@media (max-width: 600px) {
  .isMobileWrap {
    display: flex;
    justify-content:space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: 490px;
    align-content: flex-start;

  }
  .courseList {
    width: 50% !important;
    height: 110px;
    padding-left: 10px !important;
    padding-right: 10px !important;
    margin: 12px 0;
    /* margin: 10px 0; */
    /* padding-right: 5% !important;
    padding-left: 5% !important; */
  }



  .isMobileWrap .courseList:nth-child(1) {
    margin-top: 0px !important;
  }
  .isMobileWrap .courseList:nth-child(2) {
    margin-top: 0px !important;
  }

  .coureNameWrap p {
    font-size: 10px;
    margin: 0px;
    line-height: 18px;
    height: 18px;
    width: 65%;
  }

  .intoCourse span {
    font-size: 8px;
  }

  .coureNameWrap .intoCourse {
    width: 35% !important;
    line-height: 18px !important;
    height: 18px !important;
  }
  .coureNameWrap .intoCourse span {
    line-height: 18px;
    font-size: 8px;
  }
  .coureNameWrap .intoCourse .intoCourseIon {
    float: right !important;
    font-size: 12px !important;
  }
  .courseList:hover .editWrap {
    height: 80px;
  }
  .leftTag p {
    font-size: 8px;
    text-indent: 5px;
  }
  .leftTag p span {
    font-size: 8px;
  }

  .selectContent{
    width: 90px;
  }
  .selectContent p {
    font-size: 8px;
  }
  .selectContent p span {
    font-size: 8px;
  }
  .selectContent p {
    margin-bottom: 0px;
  }

  .rightTag button{
    width: 28px !important;
  }

  .createCourse {
  /* margin: 10px 0; */
  height: 105px;
  width: 140px;
  max-height: 105px;
  cursor: pointer;
  border-radius: 4px;
  padding-right: 10px !important;
  padding-left: 10px !important;

  position: relative;
}
.createCourse .addIcon{
  font-size: 20px;
  left: 50px;
  
}
.createCourse .addText{
  font-size: 17px;
  top:60px;
  left: 25px;
  
}
}

@media (max-width:1160px) {
.courseWrap{
  height: 160px !important;
}
.createCourse {
  height: 160px !important;
}
.createCourse .v-card{
  height: 160px !important;
}

.courseList{
  height: 160px !important;
}
.cardWrap{
  height: 160px !important;
}

.editWrap{
  height: 130px !important;
}
.coureListImg {
  height: 130px !important;
}
.coureNameWrap{
  height: 20px !important;
  line-height: 20px !important;
}
.coureNameWrap p{
  height: 20px !important;
  line-height: 20px !important;
  margin-bottom: 0px;
}
.coureNameWrap .intoCourse{
  height: 20px !important;
  line-height: 20px !important;
}

.coureNameWrap .intoCourse span{
  height: 20px !important;
  line-height: 20px !important;
}



/* .isMobileWrap{}

.courseList{} */
 
}

@media (max-width:850px) {
.courseWrap{

  height: 130px !important;
}
.createCourse {
  height: 100px !important;
}
.createCourse .v-card{
  height: 100px !important;
}

.createCourse .v-card .addText {
  font-size: 15px;
  bottom: 10px;
}


.courseList{
  height: 130px !important;
}
.cardWrap{
  height: 130px !important;
}
.editWrap{
  height: 100px !important;
}
.coureListImg {
  height: 100px !important;
}
.coureNameWrap{
  height: 20px !important;
  line-height: 20px !important;
}
.coureNameWrap p{
  height: 20px !important;
  line-height: 20px !important;
  width: 60%;
}
.coureNameWrap .intoCourse{
  height: 20px !important;
  line-height: 20px !important;
  width: 40% !important;
}

.coureNameWrap .intoCourse span{
  height: 20px !important;
  line-height: 20px !important;
}

 
}

@media (max-width:750px) {
.courseWrap{

  height: 100px !important;
}

.courseList{
  height: 100px !important;
}
.cardWrap{
  height: 100px !important;
}

.coureListImg {
  height: 80px !important;
}

.coureNameWrap{
  height: 20px !important; 
  line-height: 20px !important;
  margin-top: 0px;
}
.editWrap{
  height: 80px !important;
}
.coureNameWrap p{
  height: 20px !important;
  line-height: 20px !important;
  font-size: 12px;
  margin-bottom: 0px;
}
.coureNameWrap .intoCourse{
  height: 20px !important;
  line-height: 20px !important;
}

.coureNameWrap .intoCourse span{
  height: 20px !important;
  line-height: 20px !important;
  font-size: 12px;
}

 
}
</style>